import { FC } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, Card, Typography, Space } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const { Title, Text } = Typography;

const SignInPage: FC = () => {
  const { loginWithRedirect, isLoading } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignIn = async () => {
    try {
      const returnTo = (location.state as any)?.from?.pathname || '/';
      await loginWithRedirect({
        appState: {
          returnTo,
        },
      });
    } catch (error) {
      alert('Authentication error. Please check your Auth0 configuration.');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Title level={2}>Sign In</Title>
            <Text type="secondary">
              Welcome back! Please sign in to your account.
            </Text>
          </div>
          <Button
            type="primary"
            size="large"
            icon={<LoginOutlined />}
            onClick={handleSignIn}
            loading={isLoading}
            block
            style={{ height: 48 }}
          >
            Sign In with Auth0
          </Button>
          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">
              Don't have an account?{' '}
              <Button
                type="link"
                onClick={() => navigate('/signup')}
                style={{ padding: 0 }}
              >
                Sign Up
              </Button>
            </Text>
          </div>
          <p style={{ textAlign: 'center', fontSize: 8, color: '#666' }}>
            Version 0.0.1
          </p>
        </Space>
      </Card>
    </div>
  );
};

export default SignInPage;
